import { Restart } from '@clearkit/icons';
import { CKButton, CKLayoutHorizontal, CKSwitch } from 'clearkit';
import startCase from 'lodash/startCase';

import { GridList } from '~/components/unified/GridList';
import {
  usePlatformAccess,
  usePlatformAccessOverrides,
} from '~/hooks/account/usePlatformAccess';

export function AccountPlan() {
  const platformAccess = usePlatformAccess();
  const platformAccessOverrides = usePlatformAccessOverrides();
  const accessKeys = Object.keys(platformAccess);

  return (
    <GridList gridGap="1rem" gridTemplateColumns="1fr 16rem">
      <GridList.Header className="sticky top-0 z-10  px-4 py-3 border-t border-b border-gray-200 bg-gray-50">
        <div className="sticky left-0">Plan</div>
        <div className="text-right">Flag Setting</div>
      </GridList.Header>
      {accessKeys.map((key) => {
        const keyLookup = key as keyof typeof platformAccess;
        return (
          <GridList.Item className="items-center px-4 py-3" key={key}>
            <div className="sticky left-0">{startCase(key)}</div>
            <CKLayoutHorizontal gap="2rem" justifyContent="end">
              {platformAccessOverrides[keyLookup].isOverridden ? (
                <CKButton
                  leftIcon={<Restart />}
                  onClick={() => {
                    platformAccessOverrides[keyLookup].clearOverride();
                  }}
                  variant="tertiary"
                >
                  Reset flag
                </CKButton>
              ) : null}
              <CKSwitch
                checked={platformAccess[key as keyof typeof platformAccess]}
                onChange={(event) => {
                  event.preventDefault();
                  platformAccessOverrides[keyLookup].setOverrideValue(
                    event.target.checked,
                  );
                }}
              >
                <CKSwitch.LabelEnabled>true</CKSwitch.LabelEnabled>
                <CKSwitch.LabelDisabled>false</CKSwitch.LabelDisabled>
              </CKSwitch>
            </CKLayoutHorizontal>
          </GridList.Item>
        );
      })}
    </GridList>
  );
}
